import React from 'react';
import {Navigate, Route, Routes } from 'react-router-dom';
import {
    PARAMS_ADMIN_PROTECTORA,
    routes,
    routesPrefix,
} from "./routes/enums";
import LoginPage from "@/modules/AdminProtectora/views/Login";
import AdminPerfilPage from "@/modules/AdminProtectora/views/AdminPerfilPage";
import AdminPerfilParticularPage from "@/modules/AdminProtectora/views/AdminPerfilParticularPage";
import ProtectoraAdminAnimalsPage from "@/modules/AdminProtectora/views/ProtectoraAdminAnimals";
import FormAnimalPage from "@/modules/AdminProtectora/views/FormAnimal";
import ChangePassword from "@/modules/AdminProtectora/views/ChangePassword";
import PanelServicios from "@/modules/AdminProtectora/views/Servicios/";
import RegistroProtectoraPage from "@/modules/AdminProtectora/views/RegistroProtectora/views/RegistroProtectora";
import RegistroGraciasPage from "@/modules/AdminProtectora/views/RegistroProtectora/views/RegistroGracias";
import RegistroEmailVerificadoPage
    from "@/modules/AdminProtectora/views/RegistroProtectora/views/RegistroEmailVerificado";
import ContactLandingPage from "@/modules/Shared/components/Contact/ContactUsLanding";
import * as Sentry from "@sentry/react";
import AdminHall from "@/modules/AdminProtectora/views/AdminHall";
import RegistroProtectoraParticularPage
    from "@/modules/AdminProtectora/views/RegistroProtectoraParticular/";

export function renderRoutesAdminProtectora(props) {
    return (
        <Route path={routesPrefix.root} /*element={<DefaultLayout/>}*/>
            <Route index element={<AdminHall/>}/>
            <Route path={routes.login} element={<LoginPage/>}/>
            <Route path={routes.perfil} element={<AdminPerfilPage/>}/>
            <Route path={routes.perfilParticular} element={<AdminPerfilParticularPage/>}/>
            <Route path={routes.adminAnimals} /*element={<DefaultLayout/>}*/>
                <Route path={PARAMS_ADMIN_PROTECTORA.id.name} element={<ProtectoraAdminAnimalsPage/>}/>
            </Route>
            <Route path={routes.animalNuevo} element={<FormAnimalPage/>}/>
            <Route path={routes.animalModificar} element={<FormAnimalPage/>}/>
            <Route path={routes.cambiarPassword} element={<ChangePassword/>}/>
            <Route path={routes.servicios} element={<PanelServicios/>}/>
            <Route path={routes.registro} element={<RegistroProtectoraPage/>}/>
            <Route path={routes.registroParticulares} element={<RegistroProtectoraParticularPage/>}/>
            <Route path={routes.registroGracias} element={<RegistroGraciasPage/>}/>
            <Route path={routes.registroEmailVerificado} element={<RegistroEmailVerificadoPage/>}/>
            <Route path={routes.contactaConNostros} element={<ContactLandingPage/>}/>

            <Route path='*' element={<Navigate to={routesPrefix.root}/>}/>
        </Route>

    );
}
export function onChangeLocation(location) {
    try {

    } catch (e) {
        Sentry.captureException(e);
    }
}